import req from '../../api/request'
import type { SportSettings } from '../../types'

/**
 * GET /schedules/:scheduleId/settings — a competition's settings (stat
 * columns, default sorts, leaderboard display, scoring rules).
 *
 * Cached under `queryKeys.scheduleSettings.bySchedule`, which other readers of
 * this endpoint share, so it must keep returning the response's `data` as-is.
 */
export const getScheduleSettings = async (
  scheduleId: string | number
): Promise<SportSettings> => {
  const { data } = await req(`/schedules/${scheduleId}/settings`)
  return data as SportSettings
}
